import '../index.scss';
import './DateTimePicker.scss';
import MaskedTextInput from 'react-text-mask';
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import 'react-datepicker/dist/react-datepicker.css';
import DatePickerPlugin from 'react-datepicker';
import React, {useState} from "react";

type DateTimePicker = {
    date: Date,
    label: string,
    onChange: (value: any) => void,
    horizontal: boolean,
    required: boolean,
    error: string | null,
};

function DatePicker(props: DateTimePicker) {
    const autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd.mm.yyyy');
    const [clicked, setClicked] = useState<boolean>(false);

    const filterPassedTime = (time: Date): boolean => {
        const currentDate = new Date();

        return currentDate.getTime() < time.getTime();
    }

    return (
        <div className={'input' + (props.horizontal ? ' horizontal-input' : '')}>
            <label>{props.label}{props.required ? <span>*</span> : ''}</label>
            <div className={'input-container date-time-picker'}>
                <DatePickerPlugin
                    showTimeSelect
                    timeIntervals={15}
                    selected={props.date}
                    onChange={e => {
                        props.onChange(e);
                        setClicked(true)
                    }}
                    calendarStartDay={1}
                    dateFormat='dd.MM.yyyy HH:mm'
                    timeFormat='HH:mm'
                    minDate={new Date()}
                    filterTime={filterPassedTime}
                    onBlur={() => {
                        setClicked(false);
                        props.error = null
                    }
                    }
                    customInput={
                        <MaskedTextInput
                            pipe={autoCorrectedDatePipe}
                            mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
                        />
                    }
                />
                {(() => {
                    if (props.error && !clicked) {
                        return (
                            <div className='error'>
                                <svg width="18" height="17" viewBox="0 0 18 17" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.83317 6.00002H8.1665V4.33335H9.83317M9.83317 12.6667H8.1665V7.66669H9.83317M8.99984 0.166687C7.90549 0.166687 6.82185 0.382235 5.81081 0.801024C4.79976 1.21981 3.8811 1.83364 3.10728 2.60746C1.54448 4.17027 0.666504 6.28988 0.666504 8.50002C0.666504 10.7102 1.54448 12.8298 3.10728 14.3926C3.8811 15.1664 4.79976 15.7802 5.81081 16.199C6.82185 16.6178 7.90549 16.8334 8.99984 16.8334C11.21 16.8334 13.3296 15.9554 14.8924 14.3926C16.4552 12.8298 17.3332 10.7102 17.3332 8.50002C17.3332 7.40567 17.1176 6.32204 16.6988 5.31099C16.28 4.29994 15.6662 3.38128 14.8924 2.60746C14.1186 1.83364 13.1999 1.21981 12.1889 0.801024C11.1778 0.382235 10.0942 0.166687 8.99984 0.166687Z"
                                        fill="#E05D44"/>
                                </svg>
                                <span>{props.error}</span>
                            </div>
                        );
                    }
                })()}
            </div>
        </div>
    );
}

export default DatePicker;